/* eslint-disable @typescript-eslint/no-explicit-any */
import React, { useEffect, useRef } from 'react';

/**
 * Hook that alerts clicks outside of the passed ref
 */
function useOutsideAlerter({
  ref,
  onClick,
  detectTab,
}: {
  ref: React.RefObject<HTMLElement>;
  onClick: () => void;
  detectTab: boolean;
}) {
  useEffect(() => {
    /**
     * Alert if clicked on outside of element
     */
    function handleClickOutside(event: any) {
      if (ref.current && !ref.current.contains(event.target)) {
        onClick();
      }
    }
    function handleTabOutside(event: any) {
      if (event.keyCode === 9 || (event.shiftKey && event.keyCode === 9)) {
        if (!ref.current?.contains(event.target)) {
          onClick();
        }
      }
    }

    // Bind the event listener
    document.addEventListener('mousedown', handleClickOutside);
    if (detectTab) {
      document.addEventListener('keyup', handleTabOutside);
    }
    return () => {
      // Unbind the event listener on clean up
      document.removeEventListener('mousedown', handleClickOutside);
      if (detectTab) {
        document.removeEventListener('keyup', handleTabOutside);
      }
    };
  }, [ref, onClick, detectTab]);
}

/**
 * Component that alerts if you click outside of it
 */
export default function OutsideAlerter({
  onClick,
  detectTab,
  children,
}: {
  children: React.ReactNode;
  onClick: () => void;
  detectTab: boolean;
}) {
  const wrapperRef = useRef(null);
  useOutsideAlerter({ ref: wrapperRef, onClick: onClick, detectTab: detectTab });

  return <div ref={wrapperRef}>{children}</div>;
}
